/**
 * Bingo Scheduler Portlet View
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var $ = require('j');
    var BingoSchedulerItemView = require('portlets/bingo-scheduler/bingo-scheduler.item.view');
    var PortletView = require('modules/portlet/portlet.view');
    var device = require('util/device.util');
    var core = require('core');
    var ControlsView = require('portlets/bingo-scheduler/bingo-scheduler.controls.view');
    var Swipe = require('class/swipe.class');

    require('widgets/paging.widget');
    require('widgets/pagination.widget');

    module.exports = PortletView.extend({

        containerClasses: [],

        numberOfColumns: null,

        events: {
            'tap .fn-game-item': 'handleGameItemTap'
        },

        initialize: function() {
            PortletView.prototype.initialize.apply(this, arguments);

            this.options.config.portletViewMode = this.options.config.portletViewMode || 'IMAGE';

            // Lock unused checkbox - responsive on short view
            this.options.config.responsive =
                this.options.config.portletViewMode === 'SHORT' || this.options.config.responsive;

            this.controlsView = new ControlsView(this.options);
        },

        subscribe: function() {
            this.listenTo(this.model, {
                'change:gameCollection': this.renderBingoItems,
                'respondedWithError': this.renderError,
                'change:currentFetchParams': this.showLoader
            });

            this.listenTo(core, {
                'updateBingoGames': this.model.fetch,
                'bingoScheduler:changeViewMode': this.changeViewMode
            });

            if (this._shouldUseSlider()) {
                this.$el.on('paging:pageChanged', this._handlePageChange.bind(this));
            }
            if (this.options.config.responsive) {
                $.event.add(window, 'resize.bingo-scheduler', this.resizeBlocks.bind(this));
            }
        },

        render: function() {
            this.$el.html(this.tmpl('bingo-scheduler', _.extend({}, this.options, {
                usePagination: this._shouldUsePagination()
            })));

            this.controlsView.setElement(this.$('.fn-controls')[0]);
            this.controlsView.render();

            this.renderBingoItems(true);
            return this;
        },

        renderError: function(message) {
            this.$bingoItemsContainer.html(this.tmpl('bingo-scheduler.error', message));
        },

        checkContainerEntity: function(isFirstRender) {
            const bingoItemsContainer = this.$bingoItemsContainer[0];
            const childrenCount = bingoItemsContainer?.children.length;
            const gameLength = this.model.gameCollection.length;
            const { isLazy } = this.options.config;

            if (!isLazy || isLazy && (!gameLength || childrenCount <= 1)) {
                if (gameLength) {
                    bingoItemsContainer.innerHTML = '';
                } else if (isFirstRender) {
                    this.showLoader();
                } else {
                    bingoItemsContainer.innerHTML = this.tmpl('bingo-scheduler.empty', {});
                }
            }
        },

        renderBingoItems: function(data) { // deprecated
            this.drawBingoItems(data);
        },

        drawBingoItems: function(isFirstRender) {
            var collection = this.model.gameCollection;
            var length = collection.length;
            var conf = this.options.config;

            this.$bingoItemsContainer = this.$('.fn-bingo-items-container');
            conf.isLazy = this._shouldUseLazyLoading();

            if (collection) {
                this.destroyNavigation();
                this.checkContainerEntity(isFirstRender);

                if (conf.portletViewMode === 'LIST' && length) {
                    this.$bingoItemsContainer.append(
                        this.tmpl('bingo-scheduler.listHeader', _.pick(device, 'formFactor'))
                    );
                }

                length && this.renderItems(collection);
                this.setViewMods();
                this.addNavigation();
            } else {
                this.showLoader();
            }

            core.trigger('bingoScheduler:allGamesRendered');
        },

        /**
         * [renderItems]
         * @param  {[Array]} collection [Games Collection]
         */
        renderItems: function(collection) {
            var fragment = document.createDocumentFragment();
            var container = this.$bingoItemsContainer[0];
            var listHeader = container.querySelector('.fn-list-header');

            listHeader = listHeader && listHeader.cloneNode(true);

            listHeader && fragment.appendChild(listHeader);

            container.innerHTML = '';

            collection.forEach(function(model, i) {
                var view, childView;

                model.set('config', this.options.config);
                model.on('destroy', (itemModel, itemModelCollection, scroll) => {
                    this.scroll = Math.max(scroll, this.scroll || 0);
                });

                view = new BingoSchedulerItemView({ model });

                fragment.appendChild(view.render().el);

                childView = this.childViews[i];
                childView?.close(); // Stop listening events
                childView?.model?.removeTimer && clearTimeout(childView.model.removeTimer);
                childView?.model?.updateInterval && clearInterval(childView.model.updateInterval);
                this.childViews[i] = view;
            }.bind(this));

            container.appendChild(fragment);

            this.scroll && window.scrollTo(0, this.scroll); // Scroll to previous position

            delete this.scroll;
        },

        changeViewMode: function(newViewMode) {
            if (this.options.config.portletViewMode !== newViewMode) {
                this.options.config.portletViewMode = newViewMode;

                this.renderBingoItems();
            }
        },

        setViewMods: function() {
            var container = this.$bingoItemsContainer[0];
            var conf = this.options.config;
            var columns = conf.numberOfColumns;
            var viewMode = conf.portletViewMode.toLowerCase();

            this.containerClasses.forEach(function(className) {
                container.classList.remove(className);
            });

            this.containerClasses = [];

            this.containerClasses.push('bingoScheduleItemsContainer_style__' + viewMode);
            this.containerClasses.push(conf.responsive ? 'responsive' : 'columns-' + columns);

            this.containerClasses.forEach(function(className) {
                container.classList.add(className);
            });

            this.resizeBlocks();
        },

        addNavigation: function() {

            if (!this.model.gameCollection.length) {
                return;
            }

            if (this._shouldUseHorizontalScroll()) {
                this._addSwipe();
            }

            if (this._shouldUseLazyLoading()) {
                this._addLazyLoad();
            }

            if (this._shouldUseSlider()) {
                this._addNavigationByType('paging');
                var viewMode = this.options.config.portletViewMode;
                this.$('.paging-container').addClass(viewMode.toLowerCase());
            }

            if (this._shouldUsePagination()) {
                this._addNavigationByType('pagination');
                var activePage = this._getActivePage('pagination');
                this._hidePaginationArrows(activePage);
            }
        },

        destroyNavigation: function() {
            if (this._shouldUseHorizontalScroll()) {
                this._destroySwipe();
            }

            if (this._shouldUseLazyLoading()) {
                this._destroyLazyLoading();
            }

            if (this._shouldUseSlider()) {
                this._destroyNavigationByType('paging');
            }

            if (this._shouldUsePagination()) {
                this._destroyNavigationByType('pagination');
                this.$('.fn-pagination').html('');
            }
        },

        getPage: function() {
            var activePage = arguments[0];

            if (!_.isNumber(activePage)) {
                activePage = this.$el.paging('option', 'activePage') + 1;
            }

            this.model.set('currentFetchParams', _.extend({}, this.model.get('currentFetchParams'), {
                pageNumber: activePage
            }));
        },

        showLoader: function() {
            this.destroyNavigation();
            this.$bingoItemsContainer.html(this.tmpl('common.loader'));
        },

        handleGameItemTap: function(e) {
            var $game = $(e.currentTarget);

            if ($game.hasClass('disabled')) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        },

        resizeBlocks: function() {
            var $bingoItemsContainer = this.$('.fn-bingoScheduleItemsWrapper');
            var $bingoitem = this.$('.fn-bingoitem');

            if (
                !$bingoItemsContainer.length || !$bingoitem.length ||
                this.options.config.portletViewMode === 'LIST' || !this.options.config.responsive
            ) {
                return;
            }

            var itemRect = $bingoitem[0].getBoundingClientRect();
            var itemWidth = itemRect.width ? itemRect.width : itemRect.right - itemRect.left;

            var columnsCount = this._getColumnsCount();
            var numberOfColumnsChanged = this.numberOfColumns && this.numberOfColumns !== columnsCount;
            this.numberOfColumns = columnsCount;

            if (this.options.config.portletViewMode !== 'SHORT') {
                if (numberOfColumnsChanged) {
                    this.addNavigation();
                }

                $bingoitem.forEach(function(item) {
                    var marginText = 'calc((' + 100 / columnsCount + '% - ' + Math.ceil(itemWidth) + 'px) / 2)';

                    $(item).css('margin-left', marginText);
                    $(item).css('margin-right', marginText);
                });
            }
        },

        close: function() {
            $(window).off('.bingo-scheduler');

            return PortletView.prototype.close.apply(this, arguments);
        },

        _getColumnsCount: function() {
            var $bingoItemsContainer = this.$('.fn-bingoScheduleItemsWrapper');
            var $bingoitem = this.$('.fn-bingoitem');

            var itemRect = $bingoitem[0].getBoundingClientRect();
            var containerRect = $bingoItemsContainer[0].getBoundingClientRect();

            var itemWidth = itemRect.width ? itemRect.width : itemRect.right - itemRect.left;
            var containerWidth = containerRect.width ? containerRect.width : containerRect.right - containerRect.left;

            return Math.floor(containerWidth / itemWidth);
        },

        _getPageCount: function(navigationType) {
            switch (navigationType) {
                case 'paging':
                    return Math.ceil(this.model.gameCollection.length / this._getColumnsCount());
                case 'pagination':
                    return Math.ceil(this.model.get('allCount') / this.options.config.numbersOfRoom);
                default:
                    return 1;
            }
        },

        _getActivePage: function(navigationType) {
            var currentPage = this.model.get('currentPage');
            if (navigationType === 'paging') {
                var prev = this.model.previous('currentPage');
                if (_.isNumber(prev)) {
                    currentPage = prev;
                    this.model.set('currentPage', currentPage);
                }
            } else {
                currentPage += 1;
            }
            return currentPage;
        },

        _getPagingOptions: function(pagesCount, activePage) {
            return {
                activePage: activePage,
                type: 'bullet',
                arrows: true,
                infinity: false,
                lengthOfPages: pagesCount
            };
        },

        _getPaginationOptions: function(pagesCount, activePage) {
            return {
                startPage: activePage,
                pagesCount: pagesCount,
                onPageChange: this._handlePageChange.bind(this)
            };
        },

        _addNavigationByType: function(navigationType) {
            var pagesCount = this._getPageCount(navigationType);
            var activePage = this._getActivePage(navigationType);
            var $element = navigationType === 'paging'
                ? this.$el : this.$('.fn-pagination');

            if (pagesCount > 1) {
                var getOptionsMethod = navigationType === 'paging'
                    ? '_getPagingOptions' : '_getPaginationOptions';
                var options = this[getOptionsMethod](pagesCount, activePage);
                this.attachWidget($element[navigationType](options));
            }
        },

        _destroyNavigationByType: function(navigationType) {
            var $element = navigationType === 'paging'
                ? this.$el : this.$('.fn-pagination');

            if ($element && $element.isWidgetAttached(navigationType)) {
                this.detachWidget($element, navigationType);
            }
        },

        _addLazyLoad: function() {
            var lazyContainerEl = this.$bingoItemsContainer[0];

            if (!this.model.lazyLoader.isStarted() && !this.model.lazyLoader.isStopped()) {
                this.model.lazyLoader.start(lazyContainerEl);

                $(window).on('scroll', function() {
                    $(lazyContainerEl).trigger('scroll.lazyLoad');
                });
            }
        },

        _destroyLazyLoading: function() {
            //todo: Implement this method if necessary or delete
        },

        _addSwipe: function() {
            //init swipe widget
            this.swipe = new Swipe(this.$bingoItemsContainer, {
                detectingStrategy: this._detectingSwipeStrategy.bind(this)
            });

            this.swipe.on({
                move: this._handleTouchMove,
                end: this._handleTouchEnd.bind(this)
            });
        },

        _destroySwipe: function() {
            if (this.swipe) {
                this.swipe.destroy();
            }
        },

        _detectingSwipeStrategy: function(swipe, touch) {
            var isDetecting = Swipe.detectingStrategies.x.call(swipe, swipe, touch);
            var viewport = this.$el[0];
            var list = this.$bingoItemsContainer[0];
            var isSwipe = viewport.clientWidth - list.clientWidth <= 0;

            return isDetecting && isSwipe;
        },

        _handleTouchMove: function(item) {
            item.translate(item.start.x - item.delta.x, 0);
        },

        _handleTouchEnd: function(item) {
            var expected = item.position.x;
            var container = this.$el[0];
            var isStart = item.position.x > 0;
            var isEnd = Math.abs(item.position.x) >= Math.abs(container.clientWidth - item.el.clientWidth);

            if (isStart) {
                expected = 0;
            } else if (isEnd) {
                expected = container.clientWidth - item.el.clientWidth;
            }

            item.animateTo(expected, 0, 300);
        },

        _handlePageChange: function() {
            var page = arguments[0];

            if (_.isNumber(page)) {
                this.getPage(page);
            } else {
                var widget = this.$el.paging('option');
                if (widget) {
                    var activePage = widget.options.activePage;
                    this.model.set('currentPage', activePage);
                }
            }
        },

        _shouldUsePagination: function() {
            var viewMode = this.options.config.portletViewMode;
            return ['IMAGE', 'LIST'].includes(viewMode) && ['desktop', 'tablet'].includes(device.formFactor);
        },

        _shouldUseSlider: function() {
            var viewMode = this.options.config.portletViewMode;
            return viewMode === 'SHORT' && device.formFactor === 'desktop';
        },

        _shouldUseLazyLoading: function() {
            var viewMode = this.options.config.portletViewMode;
            return ['IMAGE', 'LIST'].includes(viewMode) && device.formFactor === 'mobile';
        },

        _shouldUseHorizontalScroll: function() {
            var viewMode = this.options.config.portletViewMode;
            return viewMode === 'SHORT' && ['mobile', 'tablet'].includes(device.formFactor);
        },

        _hidePaginationArrows: function(activePage) {
            var arrowSelectors = [
                '.fn-goto-page[data-page="prev"], .fn-goto-page[data-page="first"]',
                '.fn-goto-page[data-page="next"], .fn-goto-page[data-page="last"]'
            ];
            this.$(arrowSelectors[0]).toggleClass('hidden', activePage === 1);
            this.$(arrowSelectors[1]).toggleClass('hidden', activePage === this._getPageCount('pagination'));
        }
    });
});
